
export const moduleRoutes = {
    login: 'users/login/',
    otp: "users/loginOTP/",
    recover: 'users/recover/',
    reset: 'users/reset_password/',
    registerSession: 'users/registersession/',
};
